import { render, staticRenderFns } from "./control-padding.vue?vue&type=template&id=77d47d8f&"
import script from "./control-padding.vue?vue&type=script&lang=js&"
export * from "./control-padding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports